/**
 * 保存数据字典
 * @param data 数据字典
 * @returns 
 */
export async function saveDataDic(data: any) {
  return await $axios.post('/api/setting/save', data)
}

/**
 * 保存字典名称
 * @param data 数据字典
 * @returns 
 */
export async function saveDicName(data: any) {
  return await $axios.post('/api/setting/saveDicName', data)
}

/**
 * 删除字典数据
 * @param id 字典id
 * @returns 
 */
export async function removeDataDic(id: string) {
  return await $axios.delete('/api/setting/remove/' + id)
}

/**
 * 获取商户打印机
 * @returns 
 */
export async function getPrinter() {
  return await $axios.get('/api/setting/printer')
}

/**
 * 获取商户打印机
 * @returns 
 */
export async function getPrinters(id: string) {
  return await $axios.get(`/api/setting/printers/${id}`)
}

/**
 * 创建或删除打印机
 * @param data 
 * @returns 
 */
export async function createOrUpdatePrinter(data: any) {
  return await $axios.post('/api/setting/printer', data)
}

/**
 * 删除打印机
 * @param id 
 * @returns 
 */
export async function removePrinter(id: string) {
  return await $axios.delete('/api/setting/printer/' + id)
}

/**
 * 获取商户员工
 * @returns 
 */
export async function getStaffs() {
  return await $axios.get('/api/staff')
}

/**
 * 获取商户员工
 * @returns 
 */
export async function getStaffByStoreId(storeId) {
  return await $axios.get<Staff[]>('/api/staff/' + storeId)
}



/**
 * 创建或更新员工信息
 * @param data 
 * @returns 
 */
export async function createOrUpdateStaff(data: any) {
  return await $axios.post('/api/staff/createOrUpdate', data)
}

/**
 * 删除员工
 * @param id 
 * @returns 
 */
export async function removeStaff(id: string) {
  return await $axios.delete('/api/staff/' + id)
}

/**
 * 获取员工选项
 */
export async function getStaffOptions() {
  return await $axios.get('/api/staff/options')
}

/**
 * 打印机测试
 * @param id 
 * @returns 
 */
export async function printTest(id: string) {
  return await $axios.get('/api/setting/printer/test/' + id)
}

/**
 * 保存查询
 * @param dto 
 * @returns 
 */
export async function savePageSetting(dto: PageSetting) {
  return await $axios.post('/api/setting/pageSetting', dto)
}

/**
 * 删除查询
 * @param dto 
 * @returns 
 */
export async function removePageSetting(id: string) {
  return await $axios.delete('/api/setting/pageSetting/' + id)
}

/**
 * 删除查询
 * @param dto 
 * @returns 
 */
export async function renamePageSetting(dto: PageSetting) {
  return await $axios.post('/api/setting/pageSetting/rename', dto)
}

/**
 * 保存绑定信息
 * @param dto 
 * @returns 
 */
export async function saveBindInfo(dto: BindInfo) {
  return await $axios.post('/api/setting/bindInfo', dto)
}

/**
 * 获取绑定实体
 * @returns 
 */
export async function getBindEntitiesByStoreId(data: any) {
  return await $axios.post<BindEntity[]>('/api/setting/getBindEntities', data)
}

/**
 * 复制活动
 * @returns 
 */
export async function copyActivity(data: any) {
  return await $axios.post<boolean>('/api/setting/copyActivity', data)
}

/**创建物料编码 */
export async function createMaterialCode() {
  return await $axios.get<string>('/api/setting/material')
}